import React, { useEffect, useState } from 'react';
import {
	PieChart,
	Pie,
	Cell,
	Tooltip,
	Legend,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	ResponsiveContainer,
	LineChart,
	Line,
	AreaChart,
	Area,
	LabelList,
} from 'recharts';
import TableLoading from '../../../components/TableLoading';
import moment from 'moment';
import {
	formatCamelCaseToText,
	formatCurrencyNew,
	mapTimeRangeToApiFilterAlt,
	mapTimeRangeToApiFilterAlt3,
	request,
} from '../../../services/utilities';
import AnalysisBystaff from '../../../components/Modals/frontDesk/staffAnalyticsmodal';
import SlidingPane from '../../../components/SlidingPane';
import StatsModal from '../../../components/Modals/frontDesk/statsModal';
import { Card, Col, Row, Statistic } from 'antd';
import BedOccupancyHeatmap from '.././Components/HeatMap';
import { TimeRangeDropdownAlt3 as TimeRangeDropdown, TimeRangeDropdownAlt3 } from '../../../components/TimeRangeDropdownAlt3';

import { set } from 'date-fns';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#ffc0cb', '#faad14'];

export const cardColors = [
	{ bg: 'blue', text: '#fff' },
	{ bg: 'green', text: '#fff' },
	{ bg: 'brown', text: '#fff' },
	{ bg: 'red', text: '#fff' },
];

export const renderPieLabel = ({ name, value, percent }) => {
	const formattedName = String(name).charAt(0).toUpperCase() + String(name).slice(1);
	const formattedValue = formatCurrencyNew(value);
	const formattedPercent = (percent * 100).toFixed(1);
	return `${formattedName}: ${formattedValue} (${formattedPercent}%)`;
};

const mapTimeRangeToApiFilter = range => {
	switch (range) {
		case 'today':
			return 'today';
		case 'pastWeek':
			return 'past-week';
		case 'lastMonth':
			return 'last-month';
		case 'pastQuarter':
			return 'past-quarter';
		case 'pastSixMonths':
			return 'past-six-months';
		case 'pastThreeYears':
			return 'past-three-years';
		case 'past30Days':
			return 'past-month';
		case 'pastYear':
			return 'past-year';
		case 'lastYear':
			return 'last-year';
		case 'allTime':
			return 'all-time';
		default:
			return 'past-month';
	}
};

// const mapTimeRangeToApiFilterAlt = range => {
// 	switch (range) {
// 		case 'today':
// 			return 'Today';
// 		case 'pastWeek':
// 			return 'Past Week';
// 		case 'lastMonth':
// 			return 'Last Month';
// 		case 'pastQuarter':
// 			return 'Past Quarter';
// 		case 'pastSixMonths':
// 			return 'Past Six Months';
// 		case 'pastThreeYears':
// 			return 'Past Three Years';
// 		case 'past30Days':
// 			return 'Past 30 Days';
// 		case 'pastYear':
// 			return 'Past Year';
// 		case 'lastYear':
// 			return 'Last Year';
// 		case 'allTime':
// 			return 'All Time';
// 		default:
// 			return 'Past 30 Days';
// 	}
// };

const FrontDeskStaffAnalytics = ({ selectedStaff }) => {
	const [timeRanges, setTimeRanges] = useState({
		staffRanking: 'past30Days',
		appointment: 'past30Days',
		appointmentVsRegistration: 'past30Days',
		appointmentTrends: 'past30Days',
		departmentTrends: 'past30Days',
		admissionRates: 'past30Days',
		appointmentTypes: 'past30Days',
		missedCancelled: 'past30Days',
		patientDemographics: 'past30Days',
		patientAppointmentByAgeDemographics: 'past30Days',
		patientRetention: 'past30Days',
		bedOccupancy: 'past30Days',
		mortalityRate: 'past30Days',
		appointmentStatusMetrics: 'past30Days',
		transactionsMetrics: 'past30Days',
		requestCount: 'past30Days',
	});

	// Individual loading states for each chart
	const [loadingStates, setLoadingStates] = useState({
		staffRanking: false,
		appointment: false,
		appointmentStatusMetrics: false,
		appointmentVsRegistration: false,
		appointmentTrends: false,
		departmentTrends: false,
		admissionRates: false,
		appointmentTypes: false,
		missedCancelled: false,
		patientDemographics: false,
		patientAppointmentByAgeDemographics: false,
		patientRetention: false,
		bedOccupancy: false,
		mortalityRate: false,
		transactionsMetrics: false,
		requestCount: false,
	});

	// Chart data states
	const [staffRankingTop, setStaffRankingTop] = useState([]);
	const [staffRankingBottom, setStaffRankingBottom] = useState([]);
	const [allRanking, setAllRanking] = useState([]);
	const [appointmentTrends, setAppointmentTrends] = useState([]);
	const [appointmentVsRegistration, setAppointmentVsRegistration] = useState([]);
	const [appointmentTypes, setAppointmentTypes] = useState([]);
	const [missedCancelledData, setMissedCancelledData] = useState([]);
	const [patientDemographics, setPatientDemographics] = useState([]);
	const [patientRetention, setPatientRetention] = useState([]);
	const [admissionRates, setAdmissionRates] = useState([]);
	const [bedOccupancy, setBedOccupancy] = useState([]);
	const [mortalityRate, setMortalityRate] = useState(0);
	const [departmentTrends, setDepartmentTrends] = useState([]);
	const [genderAppointment, setGenderAppointment] = useState([]);
	const [consultationTypeData, setConsultationTypeData] = useState([]);
	const [appointments, setAppointments] = useState([]);
	const [registrations, setRegistrations] = useState([]);
	const [oneTimePatient, setOneTimePatient] = useState([]);
	const [occupancy, setOccupancy] = useState([]);
	const [modal, setModal] = useState(false);
	const [appMetrics, setAppMetrics] = useState();
	const [transactionMetrics, setTransactionMetrics] = useState();
	const [requestCount, setRequestCount] = useState([]);

	const COLORSe = {
		appointment: '#8884d8',
		registration: '#82ca9d',
	};

	// API fetch functions

	const fetchTransactionsMetrics = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, transactionsMetrics: true }));
		try {
			const res = await request(
				`analytics-v2/transaction-service-breakdown?type=front-desk&dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const dataAlt = {
				total: [
					{ name: 'Self Pay Amount', value: Math.abs(res?.total?.selfPayAmount) || 0 },
					{ name: 'Self Pay Paid', value: Math.abs(res?.total?.nonSelfPayAmountPaid) || 0 },
					{ name: 'Non Self Pay Amount', value: Math.abs(res.total?.nonSelfPayAmount) || 0 },
					{ name: 'non Self Pay Paid', value: Math.abs(res?.total?.nonSelfPayAmountPaid) || 0 },
				],

				summary: res?.summary?.map(({ billSource, selfPayAmount, selfPayAmountPaid, nonSelfPayAmount, nonSelfPayAmountPaid }) => ({
					item: billSource,
					data: [
						{ name: 'selfPayAmount', value: Math.abs(selfPayAmount || 0) },
						{ name: 'selfPay Paid', value: Math.abs(selfPayAmountPaid || 0) },
						{ name: 'nonSelfPayAmount', value: Math.abs(nonSelfPayAmount || 0) },
						{ name: 'nonSelfPay Paid', value: Math.abs(nonSelfPayAmountPaid || 0) },
					],
				})),
			};

			setTransactionMetrics(dataAlt);
		} catch (error) {
			console.error('Failed to fetch age range:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, transactionsMetrics: false }));
		}
	};

	const fetchAgeRange = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, patientDemographics: true }));
		try {
			const res = await request(`analytics/patients-by-age-range?date=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const demography = res?.result?.map(item => ({
				name: item?.name,
				count: parseInt(item?.count, 10),
			}));

			setPatientDemographics(demography);
		} catch (error) {
			console.error('Failed to fetch age range:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, patientDemographics: false }));
		}
	};

	// appointmentStatusMetrics
	const fetchAppointmentStatusMetrics = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, appointmentStatusMetrics: true }));
		try {
			const res = await request(`analytics/appointment-status-metrics?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const demography = res?.result;

			setAppMetrics(demography);
		} catch (error) {
			console.error('Failed to fetch age range:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, appointmentStatusMetrics: false }));
		}
	};

	const fetchTopAndBottom5 = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, staffRanking: true }));
		try {
			const res = await request(
				`analytics/staff-appointments-counts?dateFilter=${dateFilter}&requestType=labs&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);

			const transformedAppointmentsTop = res.appointments.slice(0, 5).map(item => ({
				name: item.staffUsername,
				type: 'appointment',
				value: item.appointmentCount,
			}));
			const transformedPatientsTop = res.patients.slice(0, 5).map(item => ({
				name: item.staffUsername,
				type: 'registration',
				value: item.patientCount,
			}));
			const transformedAppointmentsBottom = res.appointments
				.slice(-5)
				.reverse()
				.map(item => ({
					name: item.staffUsername,
					type: 'appointment',
					value: item.appointmentCount,
				}));
			const transformedPatientsBottom = res.patients
				// .slice(-5)
				// .reverse()
				.map(item => ({
					name: item.staffUsername,
					type: 'registration',
					value: item.patientCount,
				}));

			const transformedAppointmentsAll = res.appointments.map(item => ({
				name: item.staffUsername,
				type: 'appointment',
				value: item.appointmentCount,
			}));
			const transformedPatientsAll = res.patients.map(item => ({
				name: item.staffUsername,
				type: 'registration',
				value: item.patientCount,
			}));

			const finalAllAppointments = [...transformedAppointmentsAll, ...transformedPatientsAll];
			const finalTopData = [...transformedAppointmentsTop, ...transformedPatientsTop];
			const finalBottomData = [...transformedAppointmentsBottom, ...transformedPatientsBottom];

			const getAlternatingData = data => {
				const appointments = data.filter(item => item.type === 'appointment').sort((a, b) => b.value - a.value);
				const registrations = data.filter(item => item.type === 'registration').sort((a, b) => b.value - a.value);
				const result = [];
				for (let i = 0; i < 5; i++) {
					if (appointments[i]) result.push(appointments[i]);
					if (registrations[i]) result.push(registrations[i]);
				}
				return result;
			};

			const getAlternatingDataAlt = data => {
				const appointments = data.filter(item => item.type === 'appointment').sort((a, b) => b.value - a.value);
				const registrations = data.filter(item => item.type === 'registration').sort((a, b) => b.value - a.value);
				const result = [];
				for (let i = 0; i < 100; i++) {
					if (appointments[i]) result.push(appointments[i]);
					if (registrations[i]) result.push(registrations[i]);
				}
				return result;
			};

			setAllRanking(getAlternatingDataAlt(finalAllAppointments));
			setStaffRankingTop(getAlternatingData(finalTopData));
			setStaffRankingBottom(getAlternatingData(finalBottomData));
		} catch (error) {
			console.error('Failed to fetch staff rankings:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, staffRanking: false }));
		}
	};

	const fetchAppointmentAgeRange = async range => {
		setLoadingStates(prev => ({ ...prev, patientAppointmentByAgeDemographics: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/appontment-gender?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name: x?.gender || 'Not Specified',
				value: parseInt(x?.count, 10),
			}));
			setGenderAppointment(apiResponse);
		} catch (error) {
			console.error('Failed to fetch appointment age range:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, patientAppointmentByAgeDemographics: false }));
		}
	};

	const fetchAppointments = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, appointment: true }));
		try {
			const res = await request(`analytics/appointment-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM, YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				appointment: parseInt(x?.count, 10),
			}));
			// setAppointmentTrends(apiResponse);
			setAppointments(apiResponse);
			setAppointmentTrends([...appointmentTrends, ...apiResponse]);
		} catch (error) {
			console.error('Failed to fetch appointments:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, appointment: false }));
		}
	};

	const fetchRegistrations = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, appointmentVsRegistration: true }));
		try {
			const res = await request(`analytics/reg-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM,YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.day ||
					x?.week ||
					x?.year ||
					x?.hour,
				registrations: parseInt(x?.count),
			}));
			setRegistrations(apiResponse);
			setAppointmentTrends([...appointmentTrends, ...apiResponse]);
		} catch (error) {
			console.error('Failed to fetch appointments:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, appointmentVsRegistration: false }));
		}
	};

	const fetchAppointmentByConsultationType = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, appointmentTrends: true }));
		try {
			const res = await request(
				`analytics/appointment-consultation-type-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result;

			const revampedResponse = apiResponse?.map(item => ({
				date:
					item?.date ||
					(dateFilter == 'past-three-years' && moment(item?.month).format('MMMM,YY')) ||
					(item?.month && moment(item?.month).format('MMM')) ||
					item?.day ||
					item?.week ||
					item?.year ||
					item?.hour,
				total: parseInt(item?.totalCount, 10),
				initial: parseInt(item?.initialCount, 10),
				follow_up: parseInt(item?.followUpCount, 10),
				review: parseInt(item?.reviewCount, 10),
			}));

			setConsultationTypeData(revampedResponse);
		} catch (error) {
			console.error('Failed to fetch consultation types:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, appointmentTrends: false }));
		}
	};

	const fetchAppointmentByDepartment = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, departmentTrends: true }));
		try {
			const res = await request(
				`analytics/appointment-department-counts?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.result?.map(x => ({
				name: x?.departmentName,
				value: parseInt(x?.count, 10),
			}));
			setDepartmentTrends(apiResponse);
		} catch (error) {
			console.error('Failed to fetch department trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, departmentTrends: false }));
		}
	};

	const fetchAdmissionTrends = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, admissionRates: true }));
		try {
			const res = await request(`analytics/admission-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = res?.result?.map(x => ({
				name:
					x?.date ||
					x?.day ||
					(dateFilter == 'past-three-years' && x?.month && moment(x?.month).format('MMMM,YY')) ||
					(x?.month && moment(x?.month).format('MMMM')) ||
					x?.week ||
					x?.year ||
					x?.hour,
				admissions: parseInt(x?.count, 10),
			}));
			setAdmissionRates(apiResponse);
		} catch (error) {
			console.error('Failed to fetch admission trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, admissionRates: false }));
		}
	};

	const fetchAppointmentStatusTrends = async range => {
		const dateFilter = mapTimeRangeToApiFilter(range);
		setLoadingStates(prev => ({ ...prev, missedCancelled: true }));
		try {
			const res = await request(`analytics/appointment-status-trends?dateFilter=${dateFilter}&staffId=${selectedStaff?.id}`, 'GET', true);
			const apiResponse = res?.result;
			const result = apiResponse?.map(item => ({
				date:
					item?.date ||
					(dateFilter == 'past-three-years' && moment(item?.month).format('MMMM,YY')) ||
					(item?.month && moment(item?.month).format('MMM')) ||
					item?.day ||
					item?.week ||
					item?.year ||
					item?.hour,
				total: parseInt(item?.totalCount, 10),
				deleted: parseInt(item?.deletedCount, 10),
				pending: parseInt(item?.pendingCount, 10),
				// confirmed: parseInt(item?.confirmedCount, 10),
				No_show: parseInt(item?.noShowCount, 10),
				completed: parseInt(item?.completedCount, 10),
				cancelled: parseInt(item?.cancelledCount, 10),
				missed: parseInt(item?.noShowCount, 10),
			}));
			setMissedCancelledData(result);
		} catch (error) {
			console.error('Failed to fetch appointment status trends:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, missedCancelled: false }));
		}
	};

	const fetchMortalityRate = async () => {
		setLoadingStates(prev => ({ ...prev, mortalityRate: true }));
		try {
			const res = await request(`analytics/mortality`, 'GET', true);
			setMortalityRate(res?.mortality || 0);
		} catch (error) {
			console.error('Failed to fetch mortality rate:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, mortalityRate: false }));
		}
	};

	const fetchOccupancy = async () => {
		try {
			const res = await request(`analytics/room-count-admission`, 'GET', true);
			const formatted = (res?.result || []).map(item => ({
				name: `Bed ${item.number}`,
				occupancy: parseInt(item.count, 10),
			}));
			setOccupancy(formatted);
		} catch (error) {
			console.error('Failed to fetch occupancy:', error);
		}
	};

	const fetchOneTimePatient = async range => {
		setLoadingStates(prev => ({ ...prev, mortalityRate: true }));
		const dateFilter = mapTimeRangeToApiFilter(range);
		try {
			const res = await request(`analytics/retention-rate`, 'GET', true);
			// setMortalityRate(res?.mortality || 0);
			// const apiResponse = res?.oneTimePatients?.map(x => ({
			// 	name: x?.date || x?.day || x?.month || x?.week,
			// 	count: parseInt(x?.count, 10),
			// }));

			const onTime = {
				name: 'One-time',
				value: res?.notRetainedPatients,
			};
			const returning = {
				name: 'Returning',
				value: res?.retainedPatients,
			};

			// setOneTimePatient(apiResponse || []);
			setPatientRetention([onTime, returning]);
		} catch (error) {
			console.error('Failed to fetch mortality rate:', error);
		} finally {
			setLoadingStates(prev => ({ ...prev, mortalityRate: false }));
		}
	};

	const fetchStaffRequestCount = async range => {
		setLoadingStates(prev => ({ ...prev, requestCount: true }));
		try {
			const dateFilter = mapTimeRangeToApiFilter(range);
			const res = await request(
				`analytics-v2/staff-activity/request-count-trends?dateFilter=${dateFilter}&department=front-desk&staffId=${selectedStaff?.id}`,
				'GET',
				true
			);
			const apiResponse = res?.grouped?.['it-admin']?.map(x => ({
				name: x?.name,
				value: x?.count,
			}));
			setRequestCount(apiResponse || []);
		} catch (error) {
			console.error('Failed to fetch staff average activity time:', error);
			setRequestCount([]);
		} finally {
			setLoadingStates(prev => ({ ...prev, requestCount: false }));
		}
	};

	// Dummy data generation for charts without API
	const generateDummyData = timeRange => {
		const getTimeRangeData = (range, type) => {
			let periods;
			switch (range) {
				case 'today':
					periods = 1;
					break;
				case 'pastWeek':
					periods = 7;
					break;
				case 'past30Days':
					periods = 30;
					break;
				case 'pastYear':
					periods = 12;
					break;
				case 'allTime':
					periods = 5;
					break;
				default:
					periods = 30;
			}

			return Array.from({ length: periods }, (_, i) => {
				const dateKey =
					range === 'pastYear'
						? moment()
								.subtract(11 - i, 'months')
								.format('MMM')
						: range === 'allTime'
						? moment()
								.subtract(4 - i, 'years')
								.format('YYYY')
						: moment()
								.subtract(periods - 1 - i, 'days')
								.format('MMM D');
				return {
					name: dateKey,
					appointments:
						Math.floor(Math.random() * (range === 'allTime' ? 5000 : range === 'pastYear' ? 800 : 50)) +
						(range === 'allTime' ? 3000 : range === 'pastYear' ? 500 : 30),
					registrations:
						Math.floor(Math.random() * (range === 'allTime' ? 2500 : range === 'pastYear' ? 400 : 30)) +
						(range === 'allTime' ? 1500 : range === 'pastYear' ? 200 : 20),
				};
			});
		};

		return {
			appointmentVsRegistration: getTimeRangeData(timeRange, 'appointments'),
			appointmentTypes: [
				{ name: 'Initial Appointments', value: 65 },
				{ name: 'Follow-up Appointments', value: 35 },
			],
			patientRetention: [
				{ name: 'Returning Patients', value: 65 },
				{ name: 'One-time Patients', value: 35 },
			],
			bedOccupancy: Array.from({ length: 30 }, (_, i) => ({
				name: moment()
					.subtract(29 - i, 'days')
					.format('MMM D'),
				occupancy: Math.floor(Math.random() * 80) + 20,
				status: Math.random() > 0.7 ? 'red' : Math.random() > 0.4 ? 'yellow' : 'green',
			})),
		};
	};

	useEffect(() => {
		fetchTransactionsMetrics(timeRanges.transactionsMetrics);
		// fetchOcupancy();
		fetchOccupancy();
		fetchOneTimePatient(timeRanges.patientRetention);
		fetchRegistrations(timeRanges.appointment);
		fetchAppointments(timeRanges.appointment);
		fetchAgeRange(timeRanges.patientDemographics);
		fetchTopAndBottom5(timeRanges.staffRanking);
		fetchAppointmentAgeRange(timeRanges.patientAppointmentByAgeDemographics);
		fetchAppointmentByConsultationType(timeRanges.appointmentTrends);
		fetchAppointmentByDepartment(timeRanges.departmentTrends);
		fetchAdmissionTrends(timeRanges.admissionRates);
		fetchAppointmentStatusTrends(timeRanges.missedCancelled);
		fetchMortalityRate();
		fetchAppointmentStatusMetrics(timeRanges.appointmentStatusMetrics);
		fetchStaffRequestCount(timeRanges.requestCount);
	}, []);

	// Fetch dummy data for charts without API
	useEffect(() => {
		const { appointmentVsRegistration, appointmentTypes, patientRetention, bedOccupancy } = generateDummyData(
			timeRanges.appointmentVsRegistration
		);
		setLoadingStates(prev => ({
			...prev,
			appointmentVsRegistration: true,
			appointmentTypes: true,
			patientRetention: true,
			bedOccupancy: true,
		}));
		const timer = setTimeout(() => {
			setAppointmentVsRegistration(appointmentVsRegistration);
			setAppointmentTypes(appointmentTypes);
			setBedOccupancy(bedOccupancy);
			setLoadingStates(prev => ({
				...prev,
				appointmentVsRegistration: false,
				appointmentTypes: false,
				patientRetention: false,
				bedOccupancy: false,
			}));
		}, 1000);
		return () => clearTimeout(timer);
	}, [timeRanges.appointmentVsRegistration, timeRanges.appointmentTypes, timeRanges.patientRetention, timeRanges.bedOccupancy]);

	const handleTimeRangeChange = (range, chartId) => {
		setTimeRanges(prev => ({ ...prev, [chartId]: range }));
		switch (chartId) {
			case 'transactionsMetrics':
				fetchTransactionsMetrics(range);
				break;
			case 'patientDemographics':
				fetchAgeRange(range);
				break;
			case 'patientAppointmentByAgeDemographics':
				fetchAppointmentAgeRange(range);
				break;
			case 'appointmentVsRegistration':
				fetchRegistrations(range);
				break;
			case 'appointmentStatusMetrics':
				fetchAppointmentStatusMetrics(range);
				break;
			case 'departmentTrends':
				fetchAppointmentByDepartment(range);
				break;
			case 'appointment':
				fetchAppointments(range);
				break;
			case 'appointmentTrends':
				fetchAppointmentByConsultationType(range);
				break;
			case 'admissionRates':
				fetchAdmissionTrends(range);
				break;
			case 'missedCancelled':
				fetchAppointmentStatusTrends(range);
				break;
			case 'staffRanking':
				fetchTopAndBottom5(range);
				break;
			case 'patientRetention':
				fetchOneTimePatient(range);
				break;
			case 'requestCount':
				fetchStaffRequestCount(range);
				break;
			case 'mortalityRate':
				fetchMortalityRate();
				break;
			case 'appointmentVsRegistration':
				// Trigger dummy data update
				const { appointmentVsRegistration } = generateDummyData(range);
				setLoadingStates(prev => ({ ...prev, appointmentVsRegistration: true }));
				setTimeout(() => {
					setAppointmentVsRegistration(appointmentVsRegistration);
					setLoadingStates(prev => ({ ...prev, appointmentVsRegistration: false }));
				}, 1000);
				break;
			default:
				break;
		}
	};

	const CustomTooltip = ({ active, payload, label }) => {
		if (active && payload && payload?.length) {
			return (
				<div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
					<p className="label">{`${label}`}</p>
					{payload.map((entry, index) => (
						<p key={`item-${index}`} style={{ color: entry.color || '#000' }}>
							{`${entry.name}: ${entry.value}`}
						</p>
					))}
				</div>
			);
		}
		return null;
	};

	const renderCustomLabel = ({ name, value, percent }) => {
		return `${name}: ${value} (${(percent * 100).toFixed(1)}%)`;
	};

	const getXAxisDataKey = () => 'name';

	const mergedMap = new Map();

	appointmentTrends.forEach(entry => {
		const date = entry.date;

		if (!mergedMap.has(date)) {
			mergedMap.set(date, { date, appointment: 0, registrations: 0 });
		}

		const current = mergedMap.get(date);

		if ('appointment' in entry) {
			current.appointment = entry.appointment;
		}

		if ('registrations' in entry) {
			current.registrations = entry.registrations;
		}

		mergedMap.set(date, current);
	});

	const merged = Array.from(mergedMap.values());

	const options = {
		chart: {
			type: 'heatmap',
			toolbar: { show: false },
		},
		dataLabels: {
			enabled: true,
		},
		xaxis: {
			type: 'category',
			labels: {
				rotate: -45,
			},
		},
		colors: ['#008FFB'],
		plotOptions: {
			heatmap: {
				shadeIntensity: 0.5,
				radius: 4,
				colorScale: {
					ranges: [
						{ from: 0, to: 100, name: 'Low', color: '#ABEBC6' },
						{ from: 101, to: 300, name: 'Moderate', color: '#F9E79F' },
						{ from: 301, to: 500, name: 'High', color: '#E74C3C' },
					],
				},
			},
		},
		title: {
			text: 'Hospital Bed Occupancy Heatmap',
			align: 'left',
		},
	};

	const getColor = value => {
		if (value < 100) return '#ABEBC6';
		if (value < 300) return '#F9E79F';
		return '#E74C3C';
	};

	const renderCustomLabelAlt = ({ x, y, value, fill }) => {
		return (
			<text x={x} y={y} dy={-6} textAnchor="middle" fill={fill || '#333'} fontSize={12}>
				{value?.toLocaleString()}
			</text>
		);
	};

	const formatBarLabel = ({ x, y, value, width }) => (
		<text x={x + width / 2} y={y - 6} textAnchor="middle" fill="#333" fontSize={12}>
			{value?.toLocaleString()}
		</text>
	);

	// console.log(transactionMetrics, '------------------transactions metrix');

	return (
		<div className="content-">
			<div className="content-bo">
				<div className="row col-12">
					<div className="row col-12">
						<div className="row w-100 ">
							<div className="col-sm-12">
								<div className="element-wrapper">
									<div className=" d-flex justify-content-between align-items-center">
										<h6 className="element-header">Appointment Status Metrics</h6>
										<TimeRangeDropdownAlt3
											value={timeRanges.appointmentStatusMetrics}
											onChange={handleTimeRangeChange}
											chartId="appointmentStatusMetrics"
										/>
									</div>

									<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
										High-level metrics showing overall metrics of appointment status readings over time.
									</p>
									<div className="">
										{loadingStates.appointmentStatusMetrics ? (
											<div className="element-box">
												<TableLoading />
											</div>
										) : appMetrics?.statusBreakdown?.length > 0 ? (
											<div className="row row-cols-6 g-4">
												{/* Total Appointments */}
												<div className="col-4">
													<div className="card  p-4">
														<Statistic
															title="Total Appointments"
															value={appMetrics?.totalAppointments}
															valueStyle={{ color: 'black', fontWeight: 'bold' }}
														/>
														<small className="text-muted">
															Total Appointments for &nbsp;
															<strong>{mapTimeRangeToApiFilterAlt(timeRanges?.appointmentStatusMetrics)}</strong>
														</small>
													</div>
												</div>

												{/* Total Registrations */}
												<div className="col-4">
													<div className="card p-4">
														<Statistic
															title="Total Registrations"
															value={appMetrics?.totalRegistrations}
															valueStyle={{ color: 'black', fontWeight: 'bold' }}
														/>
														<small className="text-muted">
															Total Registrations for &nbsp;
															<strong>{mapTimeRangeToApiFilterAlt(timeRanges?.appointmentStatusMetrics)}</strong>
														</small>
													</div>
												</div>

												{/* Status Breakdown */}
												{appMetrics?.statusBreakdown
													?.filter(item => item?.status !== 'deleted')
													?.map((item, index) => {
														const percentage = ((item.count / appMetrics.totalAppointments) * 100).toFixed(1);
														return (
															<div className="col-4" key={item?.status}>
																<div className="card  p-4">
																	<Statistic
																		title={item?.status}
																		value={item?.count}
																		valueStyle={{
																			color: cardColors[index % cardColors.length].bg,
																			fontWeight: 'bold',
																		}}
																	/>
																	<small className="text-muted">
																		<strong>{percentage}%</strong> of Total Appointments for{' '}
																		<strong>{mapTimeRangeToApiFilterAlt(timeRanges?.appointmentStatusMetrics)}</strong>
																	</small>
																</div>
															</div>
														);
													})}
											</div>
										) : (
											<div className="w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
												<p className="mt-6" style={{ paddingTop: '50px' }}>
													No Record for the selected time
												</p>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="col-lg-12">
						<div className="element-wrapper">
							<h6 className="element-header">Transactions Metrics</h6>

							<div className="d-flex justify-content-end mb-4 w-100">
								<TimeRangeDropdownAlt3
									value={timeRanges.transactionsMetrics}
									onChange={handleTimeRangeChange}
									chartId="transactionsMetrics"
								/>
							</div>

							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
								This chart shows transactions metrics over the selected time period.
							</p>

							<div className="card p-4 text-capitalize">
								{loadingStates.transactionsMetrics ? (
									<TableLoading />
								) : transactionMetrics?.summary?.length > 0 ? (
									<div className="row">
										{/* Pie Chart */}
										<div className="col-6 mb-4">
											<h6>All</h6>
											<ResponsiveContainer width="100%" height={300}>
												<PieChart>
													<Pie
														data={transactionMetrics?.total || []}
														cx="50%"
														cy="50%"
														innerRadius={60}
														outerRadius={80}
														paddingAngle={5}
														dataKey="value"
														label={renderPieLabel}
														labelLine
													>
														{transactionMetrics?.total?.map((entry, index) => (
															<Cell key={`entry-${index}`} fill={COLORS[index % COLORS.length]} />
														))}
													</Pie>
													<Tooltip
														wrapperStyle={{ textTransform: 'capitalize' }}
														formatter={value => Number(value).toLocaleString()}
														nameFormatter={label => label.charAt(0).toUpperCase() + label.slice(1)}
													/>
													<Legend wrapperStyle={{ textTransform: 'capitalize' }} />
												</PieChart>
											</ResponsiveContainer>
										</div>

										{/* Summary Metrics */}
										<div className="col-6">
											{transactionMetrics?.summary
												?.filter(x => x?.item.toLowerCase() == 'registration')
												?.map((x, i) => {
													// Compute total per section for % calculations
													// const totalValue = x.data.reduce((sum, item) => sum + (item.value || 0), 0);

													const totalValue =
														x?.data?.reduce((sum, item) => {
															const name = item?.name?.toLowerCase();
															if (name === 'selfpayamount' || name === 'nonselfpayamount') {
																return sum + (Number(item.value) || 0);
															}
															return sum;
														}, 0) || 0;

													return (
														<div key={i} className="mb-4">
															<h6 className="text-capitalize mb-3 border-bottom pb-1">{x.item}</h6>

															<div className="row">
																{x.data.map((item, j) => {
																	const percentage = totalValue > 0 ? ((item.value / totalValue) * 100).toFixed(1) : 0;
																	return (
																		<div className="col-6 mb-3" key={j}>
																			<div
																				className="card p-3 shadow-sm"
																				style={{
																					borderRadius: '8px',
																				}}
																			>
																				<Statistic
																					title={formatCamelCaseToText(item.name)}
																					value={formatCurrencyNew(item.value)}
																					valueStyle={{
																						color: cardColors[j % cardColors.length].bg,
																						fontWeight: 'bold',
																					}}
																				/>
																				<small className="text-muted">
																					{percentage}% of <strong>{x.item}</strong> total
																				</small>
																			</div>
																		</div>
																	);
																})}
															</div>
														</div>
													);
												})}
										</div>

										<div className="col-12">
											{transactionMetrics?.summary
												?.filter(x => x?.item.toLowerCase() !== 'registration')
												?.map((x, i) => {
													// Compute total per section for % calculations
													const totalValue =
														x?.data?.reduce((sum, item) => {
															const name = item?.name?.toLowerCase();
															if (name === 'selfpayamount' || name === 'nonselfpayamount') {
																return sum + (Number(item.value) || 0);
															}
															return sum;
														}, 0) || 0;
													return (
														<div key={i} className="mb-4">
															<h6 className="text-capitalize mb-3 border-bottom pb-1">{x.item}</h6>

															<div className="row">
																{x.data.map((item, j) => {
																	const percentage = totalValue > 0 ? ((item.value / totalValue) * 100).toFixed(1) : 0;
																	return (
																		<div className="col-3 mb-3" key={j}>
																			<div
																				className="card p-3 shadow-sm"
																				style={{
																					borderRadius: '8px',
																				}}
																			>
																				<Statistic
																					title={formatCamelCaseToText(item.name)}
																					value={formatCurrencyNew(item.value)}
																					valueStyle={{
																						color: cardColors[j % cardColors.length].bg,
																						fontWeight: 'bold',
																					}}
																				/>
																				<small className="text-muted">
																					{percentage}% of <strong>{x.item}</strong> total
																				</small>
																			</div>
																		</div>
																	);
																})}
															</div>
														</div>
													);
												})}
										</div>
									</div>
								) : (
									<div className="w-100 d-flex justify-content-center align-items-center text-muted" style={{ height: '120px' }}>
										<p>No Record for the selected time</p>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="col-sm-6 col-lg-6">
						<div className="element-wrapper">
							<h6 className="element-header">Staff Appointment & Registration Ranking</h6>
							<h6>Top (Highest)</h6>
							<div className="d-flex justify-content-end mb-5 w-100">
								{/* <TimeRangeDropdownAlt3 value={timeRanges.staffRanking} onChange={handleTimeRangeChange} chartId="staffRanking" /> */}
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart ranks staff by their total appointments and patient registrations over the selected time period, highlighting top
								performers.
							</p>
							<div className="card">
								{loadingStates.staffRanking ? (
									<TableLoading />
								) : staffRankingTop.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer width="100%" height={400}>
											<BarChart data={staffRankingTop} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
												<CartesianGrid strokeDasharray="5 5" />
												<XAxis
													dataKey="name"
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={0}
													tickFormatter={value => {
														const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend
													wrapperStyle={{ marginBottom: '-25px' }}
													payload={[
														{ value: 'Appointment', type: 'square', id: 'ID01', color: COLORSe.appointment },
														{ value: 'Registration', type: 'square', id: 'ID02', color: COLORSe.registration },
													]}
												/>
												<Bar dataKey="value" name="Value">
													{staffRankingTop.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || '#ccc'} />
													))}
													<LabelList dataKey="value" position="top" content={formatBarLabel} />
												</Bar>
											</BarChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="col-sm-6 col-lg-6">
						<div className="element-wrapper mt-4">
							<h6 className="element-header"> </h6>
							<h6>Bottom (Lowest)</h6>
							<div className="d-flex justify-content-end w-100">
								<div>
									<div
										style={{ width: '100px', cursor: 'pointer', textAlign: 'center' }}
										onClick={() => setModal(true)}
										className="form-control form-control-sm text-white bg-primary rounded"
									>
										View All
									</div>
								</div>
								&nbsp;
								<TimeRangeDropdownAlt3 value={timeRanges.staffRanking} onChange={handleTimeRangeChange} chartId="staffRanking" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows staff with the lowest appointments and registrations, helping identify areas for improvement.
							</p>
							<div className="card">
								{loadingStates.staffRanking ? (
									<TableLoading />
								) : staffRankingBottom.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer width="100%" height={400}>
											<BarChart data={staffRankingBottom} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
												<CartesianGrid strokeDasharray="5 5" />
												<XAxis
													dataKey="name"
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={0}
													tickFormatter={value => {
														const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend
													wrapperStyle={{ marginBottom: '-25px' }}
													payload={[
														{ value: 'Appointment', type: 'square', id: 'ID01', color: COLORSe.appointment },
														{ value: 'Registration', type: 'square', id: 'ID02', color: COLORSe.registration },
													]}
												/>
												<Bar dataKey="value" name="Value">
													{staffRankingBottom.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || '#ccc'} />
													))}
													<LabelList dataKey="value" position="top" content={formatBarLabel} />
												</Bar>
											</BarChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>

					<SlidingPane isOpen={modal}>
						<div className=" content-box">
							<div className=" d-flex justify-content-end w-100">
								<button className="btn btn-danger float-end" onClick={() => setModal(false)}>
									&times;
								</button>
							</div>
							<div className="row w-100 " style={{ paddingLeft: '50px', paddingRight: '50px' }}>
								<div className="col-sm-12">
									<div className="element-wrapper">
										<div className=" d-flex justify-content-between align-items-center">
											<h6 className="element-header">Staff Appointment & Registration Ranking</h6>
											<TimeRangeDropdownAlt3 value={timeRanges.staffRanking} onChange={handleTimeRangeChange} chartId="staffRanking" />
										</div>

										<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
											High-level metrics showing overall metrics of reading over time.
										</p>
										<div className="element-box">
											{/* <TableLoading /> */}

											<Row gutter={16}>
												<Col span={8}>
													<Card>
														<Statistic
															title="Appointment Staff Count"
															value={allRanking?.filter(x => x?.type === 'appointment').length}
															suffix=""
														/>
														<small className="text-muted">
															Total Appoinment for <strong>{mapTimeRangeToApiFilterAlt(timeRanges?.staffRanking)}</strong>
														</small>
													</Card>
												</Col>
												<Col span={8}>
													<Card>
														<Statistic
															title="Registrations Staff Count"
															value={allRanking?.filter(x => x?.type === 'registration').length}
															suffix=""
														/>
														<small className="text-muted">
															Total Registrations for <strong>{mapTimeRangeToApiFilterAlt(timeRanges?.staffRanking)}</strong>
														</small>
													</Card>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</div>

							<div
								className=" w-100 d-flex justify-content-center align-items-center flex-column"
								style={{ paddingLeft: '50px', paddingRight: '50px' }}
							>
								<p className="chart-description card p-2 w-100" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
									This chart shows staffs with the lowest and highest appointments and registrations over a selected time, helping identify
									areas for improvement.
								</p>
							</div>

							<div className="" style={{ paddingLeft: '50px', paddingRight: '50px' }}>
								<div className=" card w-100 p-5">
									<ResponsiveContainer width="100%" height={400}>
										<BarChart data={allRanking} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
											<CartesianGrid strokeDasharray="5 5" />
											<XAxis
												dataKey="name"
												angle={-45}
												textAnchor="end"
												fontSize={12}
												interval={0}
												tickFormatter={value => {
													const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
													const capitalized = truncated
														.toLowerCase()
														.split(' ')
														.map(word => word.charAt(0).toUpperCase() + word.slice(1))
														.join(' ');
													return capitalized;
												}}
											/>
											<YAxis domain={[0, 'auto']} />
											<Tooltip
												formatter={value => Number(value).toLocaleString()}
												labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
											/>
											<Legend
												wrapperStyle={{ marginBottom: '-25px' }}
												payload={[
													{ value: 'Appointment', type: 'square', id: 'ID01', color: COLORSe.appointment },
													{ value: 'Registration', type: 'square', id: 'ID02', color: COLORSe.registration },
												]}
											/>
											<Bar dataKey="value" name="Value">
												{allRanking.map((entry, index) => (
													<Cell key={`cell-${index}`} fill={COLORSe[entry.type] || '#ccc'} />
												))}
												<LabelList dataKey="value" position="top" content={formatBarLabel} />
											</Bar>
										</BarChart>
									</ResponsiveContainer>
								</div>
							</div>
						</div>
					</SlidingPane>
				</div>

				{/* Appointment Ranking */}
				<div className="row col-12">
					<div className="col-sm-12 col-12">
						<div className="element-wrapper">
							<h6 className="element-header">Appointment Ranking</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3 value={timeRanges.appointment} onChange={handleTimeRangeChange} chartId="appointment" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows Appointment volumes over the selected time period to monitor patient engagement.
							</p>
							<div className="element-box">
								{loadingStates.appointment ? (
									<TableLoading />
								) : appointments.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer key={timeRanges.appointment}>
											<LineChart data={appointments} margin={{ top: 20, right: 40, left: 20, bottom: 30 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey={getXAxisDataKey()}
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={timeRanges.appointment === 'pastQuarter' ? 2 : 0}
													tickFormatter={value => {
														const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Line
													type="monotone"
													dataKey="appointment"
													stroke="#8884d8"
													strokeWidth={2}
													activeDot={{ r: 8 }}
													name="Appointments"
													connectNulls
												>
													<LabelList
														dataKey="appointment"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														// formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Line>
											</LineChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Appointment & Registration Ranking */}
				<div className="row col-12">
					<div className="col-sm-12 col-12">
						<div className="element-wrapper">
							<h6 className="element-header">Registration Trends</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3
									value={timeRanges.appointmentVsRegistration}
									onChange={handleTimeRangeChange}
									chartId="appointmentVsRegistration"
								/>
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows registration volumes over the selected time period to monitor patient engagement.
							</p>
							<div className="element-box">
								{loadingStates.appointmentVsRegistration ? (
									<TableLoading />
								) : registrations.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer key={timeRanges.appointmentVsRegistration}>
											<LineChart data={registrations} margin={{ top: 20, right: 30, left: 20, bottom: 30 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey={getXAxisDataKey()}
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={timeRanges?.appointmentVsRegistration == 'pastQuarter' ? 2 : 0}
													tickFormatter={value => {
														const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Line type="monotone" dataKey="registrations" stroke="#82ca9d" strokeWidth={2} name="Registrations" connectNulls>
													<LabelList
														dataKey="registrations"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Line>
											</LineChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Appointment Trends by Consultation Type */}
				<div className="row">
					<div className="col-sm-12">
						<div className="element-wrapper">
							<h6 className="element-header">Appointment Trends by Consultation Type</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3 value={timeRanges.appointmentTrends} onChange={handleTimeRangeChange} chartId="appointmentTrends" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart compares consultation types volumes over the selected time period to monitor patient engagement.
							</p>

							<div className="element-box">
								{loadingStates.appointmentTrends ? (
									<TableLoading />
								) : consultationTypeData.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer key={timeRanges.appointmentTrends}>
											<LineChart data={consultationTypeData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey="date"
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={timeRanges?.appointmentTrends == 'pastQuarter' ? 2 : 0}
													tickFormatter={value => {
														const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis />
												<Tooltip
													content={({ active, payload, label }) => {
														if (active && payload && payload.length) {
															const total = payload[0].payload.total; // <-- pull `total` from data row
															return (
																<div className="bg-white p-2 rounded shadow text-sm">
																	<p>
																		<strong>{label}</strong>
																	</p>
																	{payload.map((entry, index) => (
																		<p key={`item-${index}`} style={{ color: entry.color }}>
																			{entry.name}: {Number(entry.value).toLocaleString()}
																		</p>
																	))}
																	<p>
																		<strong>Total:</strong> {Number(total).toLocaleString()}
																	</p>
																</div>
															);
														}
														return null;
													}}
												/>

												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Line type="monotone" dataKey="initial" stroke="#8884d8" strokeWidth={2} name="Initial" connectNulls>
													<LabelList
														dataKey="initial"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Line>

												<Line type="monotone" dataKey="follow_up" stroke="#82ca9d" strokeWidth={2} name="Follow_up" connectNulls>
													<LabelList
														dataKey="follow_up"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Line>

												<Line type="monotone" dataKey="review" stroke="#ffc658" strokeWidth={2} name="Review" connectNulls>
													<LabelList
														dataKey="review"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Line>
											</LineChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Appointment Trends by Department */}
				<div className="row">
					<div className="col-sm-12">
						<div className="element-wrapper">
							<h6 className="element-header">Appointment Count by Department</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3 value={timeRanges.departmentTrends} onChange={handleTimeRangeChange} chartId="departmentTrends" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart displays the total number of appointments for each department over the selected time range, highlighting
								departmental workload.
							</p>
							<div className="element-box">
								{loadingStates.departmentTrends ? (
									<TableLoading />
								) : departmentTrends.length > 0 ? (
									<div style={{ width: '100%', height: 500 }}>
										<ResponsiveContainer width="100%" height={500}>
											<BarChart data={departmentTrends} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey="name"
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={0}
													tickFormatter={value => {
														const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Bar dataKey="value" name="Total Appointments">
													{departmentTrends.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
													))}
													<LabelList
														dataKey="value"
														position="top"
														content={({ x, y, value, width }) => (
															<text x={x + width / 2} y={y - 6} textAnchor="middle" fill="#333" fontSize={12}>
																{value?.toLocaleString()}
															</text>
														)}
													/>
												</Bar>
											</BarChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Appointment Type Ratio and Missed/Cancelled */}
				<div className="row">
					<div className="col-12">
						<div className="element-wrapper">
							<h6 className="element-header">Appointment Trends by Status</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3 value={timeRanges.missedCancelled} onChange={handleTimeRangeChange} chartId="missedCancelled" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart tracks and compares appointments by their status, for the selected time ranges, helping identify scheduling
								issues.
							</p>
							<div className="element-box">
								{loadingStates.missedCancelled ? (
									<TableLoading />
								) : missedCancelledData.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer key={timeRanges.missedCancelled}>
											<LineChart data={missedCancelledData} margin={{ top: 20, right: 30, left: 20, bottom: 40 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey="date"
													tick={{ fontSize: 12 }}
													angle={-45}
													top="auto"
													textAnchor="end"
													interval={timeRanges?.missedCancelled == 'pastQuarter' ? 2 : 0}
													style={{ marginTop: '400px' }}
													height={50}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													content={({ active, payload, label }) => {
														if (active && payload && payload.length) {
															const total = payload[0].payload.total; // <-- pull `total` from data row
															return (
																<div className="bg-white p-2 rounded shadow text-sm">
																	<p>
																		<strong>{label}</strong>
																	</p>
																	{payload.map((entry, index) => (
																		<p key={`item-${index}`} style={{ color: entry.color }}>
																			{entry.name}: {Number(entry.value).toLocaleString()}
																		</p>
																	))}
																	<p>
																		<strong>Total:</strong> {Number(total).toLocaleString()}
																	</p>
																</div>
															);
														}
														return null;
													}}
												/>

												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Line type="monotone" dataKey="cancelled" stroke="#ffc658" strokeWidth={2} name="cancelled" connectNulls>
													<LabelList
														dataKey="cancelled"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line>
												<Line type="monotone" dataKey="completed" stroke="#8884d8" strokeWidth={2} name="Completed" connectNulls>
													<LabelList
														dataKey="completed"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line>
												<Line type="monotone" dataKey="missed" stroke="#82ca9d" strokeWidth={2} name="Missed" connectNulls>
													<LabelList
														dataKey="missed"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line>
												<Line type="monotone" dataKey="pending" stroke="#ff7300" strokeWidth={2} name="Pending" connectNulls>
													<LabelList
														dataKey="pending"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line>
												<Line type="monotone" dataKey="No_show" stroke="#ff4d4f" strokeWidth={2} name="No Show" connectNulls>
													<LabelList
														dataKey="No_show"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line>

												{/* <Line type="monotone" dataKey="deleted" stroke="purple" strokeWidth={2} name="deleted" connectNulls>
													<LabelList
														dataKey="deleted"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
													/>
												</Line> */}
											</LineChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Patient Demographics */}
				<div className="row">
					<div className="col-sm-6">
						<div className="element-wrapper">
							<h6 className="element-header">Patient Age Demography </h6>
							<div className="d-flex justify-content-end w-100">
								&nbsp;
								<br />
								<br />
								{/* <TimeRangeDropdownAlt3 value={timeRanges.patientDemographics} onChange={handleTimeRangeChange} chartId="patientDemographics" /> */}
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows patient distribution by age group, aiding in demographic analysis.
							</p>
							<div className="element-box">
								{loadingStates.patientDemographics ? (
									<TableLoading />
								) : patientDemographics.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer>
											<BarChart
												data={patientDemographics}
												// layout="vertical"
												margin={{ top: 20, right: 30, left: 40, bottom: 40 }}
												stackOffset="positive"
											>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey={'name'}
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={0}
													tickFormatter={value => {
														const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												{/* <Legend /> */}
												<Bar dataKey="count" stackId="a" fill="#8884d8">
													<LabelList
														dataKey="count"
														position="center"
														style={{ fontSize: '12px', fill: '#fff' }}
														formatter={value => `${value}`}
													/>
												</Bar>
											</BarChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="col-sm-6">
						<div className="element-wrapper">
							<h6 className="element-header">Patient Appointment by Gender Distribution</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3
									value={timeRanges.patientAppointmentByAgeDemographics}
									onChange={handleTimeRangeChange}
									chartId="patientAppointmentByAgeDemographics"
								/>
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows appointment distribution by gender, aiding in demographic analysis.
							</p>
							<div className="element-box">
								{loadingStates.patientAppointmentByAgeDemographics ? (
									<TableLoading />
								) : genderAppointment.length > 0 ? (
									<div style={{ width: '100%', height: 400 }}>
										<ResponsiveContainer>
											<PieChart>
												<Pie
													data={genderAppointment.filter(x => x?.name != 'Not Specified')}
													cx="50%"
													cy="50%"
													innerRadius={60}
													outerRadius={80}
													fill="#8884d8"
													paddingAngle={5}
													dataKey="value"
													label={renderPieLabel}
													labelLine
												>
													{genderAppointment.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
													))}
												</Pie>
												<Tooltip
													wrapperStyle={{ textTransform: 'capitalize' }}
													formatter={value => Number(value).toLocaleString()}
													nameFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend wrapperStyle={{ textTransform: 'capitalize' }} />
											</PieChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Patient Retention */}
				<div className="row">
					<div className="col-sm-9">
						<div className="element-wrapper">
							<h6 className="element-header">Patient Retention</h6>
							<div className="d-flex justify-content-end w-100">
								{/* <TimeRangeDropdownAlt3 value={timeRanges.patientRetention} onChange={handleTimeRangeChange} chartId="patientRetention" /> */}
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart illustrates the percentage of returning versus one-time patients, providing insight into patient loyalty. (Note:
								Patients with 5 or more visits are considered returning.)
							</p>

							<div className="element-box">
								{loadingStates.patientRetention ? (
									<TableLoading />
								) : patientRetention.length > 0 ? (
									<div style={{ width: '100%', height: 300 }}>
										<ResponsiveContainer>
											<PieChart>
												<Pie
													data={patientRetention}
													cx="50%"
													cy="50%"
													innerRadius={60}
													outerRadius={80}
													fill="#8884d8"
													paddingAngle={5}
													dataKey="value"
													label={renderCustomLabel}
													labelLine
												>
													{patientRetention.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
													))}
												</Pie>
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend />
											</PieChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="element-wrapper">
							<h6 className="element-header">Mortality Rate</h6>

							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This metric displays the number of deceased patients based on marked records.
							</p>
							<div className="element-box">
								{loadingStates.mortalityRate ? (
									<TableLoading />
								) : (
									<div className="el-tablo">
										<div className="value" style={{ fontSize: '48px', color: '#ff4d4f' }}>
											{mortalityRate}
										</div>
										<div className="label">Based on marked deceased patients</div>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="col-sm-12">
						<div className="element-wrapper">
							<h6 className="element-header">Admission Rates</h6>
							<div className="d-flex justify-content-end w-100">
								<TimeRangeDropdownAlt3 value={timeRanges.admissionRates} onChange={handleTimeRangeChange} chartId="admissionRates" />
							</div>
							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart tracks hospital's active admissions for every date/ time range over time, indicating demand for in-patient
								services.
							</p>
							<div className="element-box">
								{loadingStates.admissionRates ? (
									<TableLoading />
								) : admissionRates.length > 0 ? (
									<div style={{ width: '100%', height: 300 }}>
										<ResponsiveContainer>
											<AreaChart data={admissionRates} margin={{ top: 20, right: 20, left: 20, bottom: 40 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis
													dataKey={getXAxisDataKey()}
													angle={-45}
													textAnchor="end"
													fontSize={12}
													interval={timeRanges.admissionRates == 'pastQuarter' ? 2 : 0}
													tickFormatter={value => {
														const truncated = value.length > 15 ? value.substring(0, 15) + '...' : value;
														const capitalized = truncated
															.toLowerCase()
															.split(' ')
															.map(word => word.charAt(0).toUpperCase() + word.slice(1))
															.join(' ');
														return capitalized;
													}}
												/>
												<YAxis domain={[0, 'auto']} />
												<Tooltip
													formatter={value => Number(value).toLocaleString()}
													labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
												/>
												<Legend wrapperStyle={{ marginBottom: '-40px' }} />
												<Area type="monotone" dataKey="admissions" stroke="#8884d8" fill="#8884d8" name="Admissions">
													<LabelList
														dataKey="admissions"
														position="top"
														style={{ fontSize: '12px', fill: '#333' }}
														formatter={value => `${value}`}
														content={renderCustomLabelAlt}
													/>
												</Area>
											</AreaChart>
										</ResponsiveContainer>
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				<div className="col-sm-12 ">
					<div className="element-wrapper">
						<h6 className="element-header">Staff Activity Trends</h6>
						<div className="d-flex justify-content-end w-100">
							<TimeRangeDropdownAlt3 value={timeRanges.requestCount} onChange={handleTimeRangeChange} chartId="requestCount" />
						</div>
						<p className="chart-description mb-3 p-2 card">This chart shows staff activity trends.</p>

						<div className="element-box">
							{loadingStates?.requestCount ? (
								<TableLoading />
							) : requestCount?.length > 0 ? (
								<div style={{ height: '400px' }}>
									<ResponsiveContainer>
										<LineChart data={requestCount} margin={{ top: 20, right: 20, left: 10, bottom: 20 }}>
											<CartesianGrid strokeDasharray="3 3" />
											<XAxis
												dataKey={'name'}
												angle={-45}
												textAnchor="end"
												fontSize={12}
												interval={0}
												tickFormatter={value => {
													const truncated = value.length > 10 ? value.substring(0, 10) + '...' : value;
													const capitalized = truncated
														.toLowerCase()
														.split(' ')
														.map(word => word.charAt(0).toUpperCase() + word.slice(1))
														.join(' ');
													return capitalized;
												}}
											/>
											<YAxis domain={[0, 'auto']} />
											<Tooltip
											// formatter={value => formatDuration(value)}
											// labelFormatter={label => String(label).charAt(0).toUpperCase() + String(label).slice(1)}
											/>
											<Legend wrapperStyle={{ marginBottom: '-45px' }} />
											<Line
												type="monotone"
												dataKey="value"
												name="count"
												stroke="#22BB33"
												strokeWidth={2}
												dot={{ r: 4 }}
												activeDot={{ r: 6 }}
											>
												<LabelList
													dataKey="value"
													name="count"
													// content={renderCustomLabelAlt}
													position="top"
													style={{ fontSize: '10px', fill: '#333' }}
												/>
											</Line>
										</LineChart>
									</ResponsiveContainer>
								</div>
							) : (
								<div className="text-center fs-bold">No Record Found!</div>
							)}
						</div>
					</div>
				</div>

				{/* Bed Occupancy and Mortality */}
				<div className="row">
					<div className="col-sm-12">
						<div className="element-wrapper">
							<h6 className="element-header">Bed usage </h6>

							<p className="chart-description card p-2" style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
								This chart shows an all time bed usage rates, with colors indicating low (green), medium (yellow), and high (red).
							</p>
							<div className="element-box">
								{loadingStates.bedOccupancy ? (
									<TableLoading />
								) : occupancy.length > 0 ? (
									<div style={{ width: '100%', height: 300 }}>
										<BedOccupancyHeatmap data={occupancy} />
										{/* <ResponsiveContainer>
											<BarChart data={occupancy} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
												<CartesianGrid strokeDasharray="3 3" />
												<XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} height={80} />
												<YAxis />
												<Tooltip />
												<Bar dataKey="occupancy" name="Bed Occupancy">
													{occupancy.map((entry, index) => (
														<Cell key={`cell-${index}`} fill={getColor(entry.occupancy)} />
													))}
												</Bar>
											</BarChart>
										</ResponsiveContainer> */}
									</div>
								) : (
									<div className=" w-100 card d-flex justify-content-center align-items-center" style={{ height: '50px' }}>
										<p className=" mt-6" style={{ paddingTop: '50px' }}>
											No Record for the selected time
										</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

// export default FrontDeskAnalytics;

export default FrontDeskStaffAnalytics;
